import Api from '@/vuex/api'
import {
  OPEN_MODAL,
  LOGIN_AS_USER,
  LOAD_ACCOUNT,
  GENERATE_ACTIVITY_STATEMENT,
  EDIT_ACTIVITY_STATEMENT
} from '@/vuex/types'

const api = new Api()
const state = {
  account: {
    uuid: '',
    AccountType: {}
  }
}

const mutations = {
  [LOAD_ACCOUNT] (state, account) {
    state.account = account
  }
}

const actions = {
  async [LOGIN_AS_USER] (context, account) {
    let link = await api.loginAsUser(account)
    let html = `
      <p>
        <strong>User:</strong> ${account.fullName}
      </p>
      <div class="alert alert-info">
        <strong>
          Remember to log out of the account once finished.
        </strong>
      </div>
      <p>
        ${link}
      </p>
    `
    let loginAsUserModal = {
      title: 'Login As User',
      html
    }
    context.dispatch(OPEN_MODAL, loginAsUserModal)
  },
  async [LOAD_ACCOUNT] (context, accountUuid) {
    let { account } = await api.getUser(accountUuid)
    context.commit(LOAD_ACCOUNT, { account: { ...account } })
  },
  async [GENERATE_ACTIVITY_STATEMENT] (context, payload) {
    let generateStaffActivityStatementModal = {
      permalink: 'generateStaffActivityStatement',
      options: {
        title: 'Generate Activity Statement',
        actionLabel: 'Generate'
      },
      params: {
        uuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, generateStaffActivityStatementModal)
  },
  async [EDIT_ACTIVITY_STATEMENT] (context, payload) {
    let editStaffActivityStatementModal = {
      permalink: 'editStaffActivityStatement',
      options: {
        title: 'Edit Activity Statements',
        actionLabel: 'Save'
      },
      params: {
        uuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editStaffActivityStatementModal)
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/account.js